//import moment from 'moment'
import Vue from 'vue'
import CryptoJS from 'crypto-js'
import { TokenService } from '@/services/storage.service'

export const getOptions = (url, method, token1, payload, direct) => {
  // if((url.search('ticketak') == -1 || url.search('gogo') == -1) && direct){
  //     url = 'http://api.ticketak.com' + url
  // }
  const token = TokenService.getToken() ? TokenService.getToken() : token1 ? token1 : TokenService.getToken()
  let options = {
    method: method || 'GET',
    url: url,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    }
  }
  if (token) {
    options.headers.Authorization = token
  }

  // if (token) {
  //     options.headers['Authorization'] = `Bearer ${token}`
  // }

  if (method == 'GET' && payload) {
    options['params'] = payload
  }

  if (payload) {
    options['method'] = method || 'POST'
    options['data'] = payload
  }
  return options
}

export const getCurrentDate = () => {
  const dateTime = new Date()
  const date = dateTime.getDate()
  const month = dateTime.getMonth() + 1 // increment month by 1
  const year = dateTime.getFullYear()
  return year + '/' + month + '/' + date
}

export const formatDate = Vue.filter('formatDate', function (value) {
  if (value) {
    //return moment(String(value)).format('MMMM Do YYYY, h:mm:ss a')
  }
})

export const decodeFrontUserToken = token => {
  // console.log("here Front token >>", token)
  return JSON.parse(CryptoJS.AES.decrypt(token, 'HereIsTheMyEncryptedCryptoSecretLOL').toString(CryptoJS.enc.Utf8))
}



// WEBPACK FOOTER //
// ./src/helper/collection.js